import React from 'react';

interface ConfigurationErrorProps {
    missingVars: string[];
}

const ConfigurationError: React.FC<ConfigurationErrorProps> = ({ missingVars }) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '20px'
        }}>
            <div style={{ 
                textAlign: 'center', 
                maxWidth: '600px',
                background: 'rgba(255,255,255,0.1)',
                padding: '40px',
                borderRadius: '10px',
                backdropFilter: 'blur(10px)'
            }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚙️</div>
                <h1 style={{ marginBottom: '20px' }}>Configuration Required</h1>
                <p style={{ marginBottom: '20px', opacity: 0.9 }}>
                    The application is missing required environment variables:
                </p>
                <ul style={{ 
                    textAlign: 'left', 
                    marginBottom: '30px',
                    background: 'rgba(0,0,0,0.2)',
                    padding: '20px',
                    borderRadius: '5px',
                    listStyle: 'none'
                }}>
                    {missingVars.map(varName => (
                        <li key={varName} style={{ marginBottom: '5px' }}>
                            ❌ {varName}
                        </li>
                    ))}
                </ul>
                <div style={{ 
                    background: 'rgba(0,0,0,0.2)',
                    padding: '20px',
                    borderRadius: '5px',
                    marginBottom: '20px',
                    textAlign: 'left'
                }}>
                    <h3 style={{ marginBottom: '10px' }}>To fix this:</h3>
                    <ol style={{ paddingLeft: '20px' }}>
                        <li>Deploy the CDK infrastructure first</li>
                        <li>Run: <code style={{ background: 'rgba(255,255,255,0.2)', padding: '2px 6px', borderRadius: '3px' }}>
                            ./scripts/update-frontend-env.sh dev
                        </code></li>
                        <li>Restart the development server</li>
                    </ol>
                </div>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        background: 'rgba(255,255,255,0.2)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '16px',
                    }}
                >
                    Reload Page
                </button>
            </div>
        </div>
    );
};

export default ConfigurationError;